<template>
    <div v-if="content" class="mt-4 text-info">
        <h2 class="mb-3 text-info-title">{{ content.name }}</h2>
        <div class="text-info-text" v-html="content.text1"></div>
        <div v-if="isArray">
            <h2 class="mb-3 text-info-title"> Dúvidas frequentes </h2>
            <div class="accordion" role="tablist">
                <b-card no-body class="border-0 mb-3" v-for="item in content" :key="item.id">
                    <b-button block v-b-toggle="`accordion-${item.id}`" class="text-left call-center-accordion-btn d-flex justify-content-between" @click="idVisible == item.id ? idVisible = null : idVisible = item.id">
                        <div>{{ item.name }}</div>
                        <div v-if="idVisible && idVisible == item.id">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="3">
                                <rect width="500" height="38" fill="#000" class="call-center-accordion-btn-icon"/>
                            </svg>
                        </div>
                        <div v-else>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" class="call-center-accordion-btn-icon"><path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>
                        </div>
                    </b-button>
                    <b-collapse :id="`accordion-${item.id}`" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text v-html="item.text1" class="call-center-accordion-text"></b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    props:[
        'content',
        'isArray'
    ],
    data(){
        return{
            idVisible: null
        }
    }
}
</script>
